import { useAggregationsData } from "./useAggregationsData";

export function useMagentoCatalogFilterlessAggData(
  categoryId: MaybeRef<string | undefined>,
  term: MaybeRef<string | undefined>,
  options?: { key?: string },
) {
  return useAggregationsData(
    computed(() => ({
      ...(unref(term) ? { search: unref(term) } : {}),
      currentPage: 1,
      pageSize: 0,
      filter: {
        ...(unref(categoryId)
          ? {
              category_uid: {
                eq: unref(categoryId),
              },
            }
          : {}),
      },
    })),
    { key: options?.key },
  );
}
